import { Component, OnInit } from '@angular/core';

import { GoogleAnalyticsService } from './services/google-analytics/google-analytics.service';
import { Logging } from './utils/logging';
import { UserService } from './services/user/user.service';
import { EnvironmentVariablesService } from './services/environment-variables.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  title = 'Cross-Reference Management';
  isAuthenticated: boolean;
  UserName = '';
  baseUrl = window.location.origin;

  notificationsShown = false;
  notificationModalOrigin = this.environmentVariables.NOTIFICATIONS_URL;
  notificationModalUrl =
    this.environmentVariables.NOTIFICATIONS_URL +
    '/currentNotifications/' +
    this.environmentVariables.PRODUCT_ID +
    '/' +
    this.environmentVariables.APPLICATION_NAME;

  constructor(
    public user: UserService,
    public gaService: GoogleAnalyticsService,
    public environmentVariables: EnvironmentVariablesService,
  ) {
    this.handleEvent = this.handleEvent.bind(this);
  }

  public loadGoogleAnalyticsScript() {
    this.gaService
      .initialize()
      .then(() => {
        Logging.info('Google Analytics loaded successfully');
      })
      .catch(error => {
        Logging.error('Failed to load Google Analytics', error);
      });
  }
  load: Promise<any>;

  ngOnInit(): void {
    this.load = new Promise(() => {
      this.loadGoogleAnalyticsScript();
    });
    this.user.userName.subscribe(value => {
      this.UserName = value;
    });

    window.addEventListener('message', this.handleEvent);
  }

  public handleEvent(event: MessageEvent) {
    if (event.origin !== this.notificationModalOrigin) {
      return null;
    }
    this.notificationsShown = !!event.data;
  }
}
